import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import {RcsConnectorIndexDbProvider} from "../../providers/rcs-connector-index-db/rcs-connector-index-db";

@IonicPage()
@Component({
  selector: 'page-job-implementation',
  templateUrl: 'job-implementation.html',
})
export class JobImplementationPage {

  public finishline_form:FormGroup
  private finishline_element: any
  public job: any
  public job_mode: string
  public product: any
  public qty_error: boolean = false;
  private action: string = 'normal'
  private user: any

    constructor(
      private params: NavParams,
      private db: RcsConnectorIndexDbProvider,
      private formBuilder: FormBuilder,
      private nav_controller: NavController,
      private toast_controller: ToastController,
    ){
        this.finishline_form = this.formBuilder.group({
          product: ['', Validators.required],
          qty_real: [''],
          qty: ['']
        });
      }

    ngOnInit(){
      this.job = this.params.get('job')
      if (this.params.get('finishline')){
        this.finishline_element = this.params.get('finishline');
        this.product = {id: this.finishline_element.product_id[0], name: this.finishline_element.product_id[1]};
      }
      if (this.params.get('job_mode')){
        this.job_mode = this.params.get('job_mode');
      }
      this.db.search_by_key('login', 'user_login').subscribe(user => {
        this.user = user
      })
    }

      get_product(event) {
          this.product = event;
      }

      public submit(prototyp:any){
        let result = this.finishline_form.value;
        this.finishline_element.product_id[0] = this.product.id;
        if (result.qty_real !== '0' && result.qty !== '0' || this.finishline_element.create_uid[0] !== this.user.uid){
          const finishline_element = this.validate(prototyp, result)
          const index = this.job.orderline.indexOf(this.finishline_element)
          console.log(finishline_element)
          console.log(index)
          if (index >= 0){
            this.job.orderline[index] = finishline_element
          }else{
            this.job.orderline.push(finishline_element)
          }
          this.nav_controller.pop();
        }else{
          this.error_handling();
          this.qty_error = true;
        }
      }

      public abort(){
          this.nav_controller.pop();
      }

      private error_handling() {
        let toast = this.toast_controller.create({
          message: 'Die Menge darf nicht 0 sein!',
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }

      private validate(finishline:any, result: any){
        if (this.action !== 'abort'){
          finishline.product_id[0] = parseFloat(this.product.id);
          finishline.product_id[1] = this.product.name;

          if (result.qty !== ''){
            finishline.qty = parseFloat(result.qty);
          }
          if (result.qty_real !== ''){
            finishline.qty_real = parseFloat(result.qty_real);
          }
        }
        return finishline;
      }
}



// WEBPACK FOOTER //
// ./src/pages/job-implementation/job-implementation.ts